module.exports = __webpack_public_path__ + "img/20210430_110931.6df43c27.jpg";